import React, { Component } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

import Swing from "react-reveal/Swing";
import Fade from "react-reveal/Fade";

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      submitted: false,
      formError: false
    };
  }

  handleSubmit = values => {
    const form = document.forms["contact"];
    const URL =
      "https://script.google.com/macros/s/AKfycbzL4O5TJi3a8h0-axfEeO9i_KhjhmtxChtSAUhpV42RKe0Mzq0/exec";

    this.setState({ isLoading: true });
    fetch(URL, {
      method: "POST",
      body: new FormData(form)
    })
      .then(res => {
        this.setState({
          submitted: true,
          isLoading: false
        });
      })
      .catch(err =>
        this.setState({
          formerror: true
        })
      );
  };

  render() {
    if (this.state.submitted) {
      return (
        <div className="Contact">
          <Fade>
            <p style={{ textAlign: "center" }}>
              Thank you for your message! I'll be in touch as soon as possible.
              <br />
              <br />
              Koen
            </p>
          </Fade>
        </div>
      );
    } else if (this.state.isLoading) {
      return (
        <div className="Contact">
          <Fade>
            <Swing forever>
              <div style={{ textAlign: "center" }}>
                <FontAwesomeIcon
                  style={{ width: "100px", height: "auto", marginTop: "50px" }}
                  icon={faPaperPlane}
                />
                <p>Sending...</p>
              </div>
            </Swing>
          </Fade>
        </div>
      );
    } else {
      return (
        <div className="Contact">
          <Formik
            initialValues={{ email: "", message: "" }}
            validate={values => {
              let errors = {};
              if (!values.email) {
                errors.email = "Required";
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = "Invalid email address";
              }
              if (!values.message) {
                errors.message = "Please enter a message";
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              this.handleSubmit(values);
              setSubmitting(false);
            }}
          >
            {({ isSubmitting }) => (
              <Form name="contact" autoComplete="off">
                <Field type="email" name="email" placeholder="email" />
                <ErrorMessage name="email" component="div" />
                <Field
                  component="textarea"
                  name="message"
                  placeholder="message"
                />
                <ErrorMessage name="message" component="div" />
                <button type="submit" disabled={isSubmitting}>
                  Send
                </button>
              </Form>
            )}
          </Formik>
          {this.state.formError && (
            <p style={{ color: "red" }}>
              Something went wrong submitting the form.
              <br />
              Please try again
            </p>
          )}
        </div>
      );
    }
  }
}
